import React, { type ReactNode } from "react";
import PageLayout from "./PageLayout";

interface UserLayoutProps {
  children: ReactNode;
  showHeroSection?: boolean;
  heroContent?: React.ReactNode;
}

const UserLayout: React.FC<UserLayoutProps> = ({
  children,
  showHeroSection = false,
  heroContent,
}) => {
  return (
    <PageLayout>
      {showHeroSection ? (
        <>
          {/* Hero Section - extends behind header */}
          {heroContent}

          {/* Main Content Below Hero */}
          <section className="max-w-screen-1600 mx-auto h-full flex-1 px-4 py-10 md:px-6">
            {children}
          </section>
        </>
      ) : (
        /* No Hero - Content with top padding to clear header */
        <div className="pt-26 sm:pt-24">
          <div className="flex justify-center">
            <div className="max-w-screen-1600 flex w-full px-4 md:px-6">
              <div className="container mx-auto max-w-full">{children}</div>
            </div>
          </div>
        </div>
      )}
      <footer className="mt-10 w-full py-6 text-center text-sm"></footer>
    </PageLayout>
  );
};

export default UserLayout;
